import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { clsx } from '../../../ds/clsx';
import { Banner, Toggle } from '../../../ds/components';
import { errorMessage } from '../../../lib/api';
import { queryRoots } from '../../../lib/events';
import { updateCampaign, type ListDetail } from '../api';
import styles from './lists.module.css';

/**
 * „Prio-Kampagne" of a campaign list (no frame, D-208): the switch sets `campaign.priority`; leads of a
 * priority campaign are drawn before every other dialable contact. Users without `settings.organization`
 * see the switch read-only.
 */
export function CampaignPriorityCard({ list, canManage }: { list: ListDetail; canManage: boolean }) {
  const queryClient = useQueryClient();
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);
  const campaign = list.campaign;
  if (campaign === null) return null;

  async function change(checked: boolean) {
    if (campaign === null) return;
    setPending(true);
    setError(null);
    try {
      await updateCampaign(campaign.id, { priority: checked ? 1 : 0 });
      await queryClient.invalidateQueries({ queryKey: [...queryRoots.dialer] });
    } catch (caught) {
      setError(errorMessage(caught));
    } finally {
      setPending(false);
    }
  }

  return (
    <section className={clsx(styles.sideCard, styles.priorityCard)} aria-label="Prio-Kampagne">
      {error ? <Banner tone="danger">{error}</Banner> : null}
      <Toggle
        label="Prio-Kampagne"
        checked={campaign.priority === 1}
        locked={!canManage}
        disabled={pending}
        onChange={(checked) => void change(checked)}
      />
      <span className={styles.fieldHelp}>Leads dieser Kampagne werden vor allen anderen angerufen.</span>
    </section>
  );
}
